import React from "react";
import { ArrowUpRight } from "lucide-react";
import projects from "../../../data/data";
import "./ProductPortfolio.css";

function ProductPortfolio() {
  return (
    <section id="products" className="product-portfolio section-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="sec-title text-center wow animate fadeInUp">
              <span>The Portfolio</span>
              <h2>Three Products, One Company</h2>
              <p>
                Each product solves a different problem for a different
                market. All three are live in production today, and all three
                are built, shipped and operated by the same team.
              </p>
            </div>
          </div>
        </div>

        <div className="portfolio-grid">
          {projects.map((product) => (
            <article key={product.id} className="portfolio-card">
              <div className="portfolio-card-media">
                <img
                  src={process.env.PUBLIC_URL + "/" + product.image}
                  alt={`${product.name} brand card`}
                  loading="lazy"
                />
              </div>

              <div className="portfolio-card-body">
                <span className="portfolio-card-category">
                  {product.category}
                </span>
                <h3 className="portfolio-card-name">{product.name}</h3>
                <p className="portfolio-card-summary">{product.summary}</p>

                <div className="portfolio-card-footer">
                  <div className="portfolio-card-stat">
                    <strong>{product.usersLabel}</strong>
                    <span>{product.usersNoun}</span>
                  </div>
                  <a
                    className="portfolio-card-link"
                    href={product.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Visit <ArrowUpRight size={17} />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProductPortfolio;
